import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconSentimentVeryDissatisfiedFilled = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconSentimentVeryDissatisfiedFilled",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M11.99 2A10 10 0 1 0 12 21.99 10 10 0 0 0 11.99 2M7 9.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m7 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-6.65 7.08a5.48 5.48 0 0 1 9.31 0c.22.35.11.81-.24 1.03a1 1 0 0 1-.4.11.7.7 0 0 1-.64-.35 3.97 3.97 0 0 0-6.76 0 .75.75 0 1 1-1.27-.79"
  })
}));
IconSentimentVeryDissatisfiedFilled.displayName = 'IconSentimentVeryDissatisfiedFilled';